import { TeamRole } from '@this+that/models';

export const TEAM_FETCH_LIMIT = 100;

export enum TEAM_TAB {
  MEMBERS = 'MEMBERS',
  PENDING = 'PENDING',
  BILLING = 'BILLING',
}

export enum TEAM_WORKSPACE_TYPE {
  TEAM = 'TEAM',
  CLIENT = 'CLIENT',
}

export enum TEAM_HUB_SECTION_LAYOUT {
  GRID = 'grid',
  LIST = 'list',
}

// Shows the Billing tab on the Team page.
export const IS_BILLING_TAB_ENABLED = true;

export const INVITE_ROLES = [
  { role: TeamRole.ADMIN, descKey: 'teamHub.inviteRoles.admin.description' },
  { role: TeamRole.MEMBER, descKey: 'teamHub.inviteRoles.member.description' },
  { role: TeamRole.VIEWER, descKey: 'teamHub.inviteRoles.viewer.description' },
] as const;

export const CONSULTANT_INVITE_ROLE = {
  role: TeamRole.CONSULTANT,
  descKey: 'teamHub.inviteRoles.consultant.description',
} as const;

export enum TEAM_QUERY_PARAM {
  TAB = 'tab',
  CHECKOUT = 'checkout',
}

export enum TEAM_QUERY_PARAM_VALUE {
  BILLING_TAB = 'billing',
  CHECKOUT_SUCCESS = 'success',
}

export const CHECKOUT_FINALIZING_POLL_INTERVAL_MS = 3000;
export const CHECKOUT_FINALIZING_MAX_DURATION_MS = 30000;
